import React from 'react'
import styled from 'styled-components'

const StyledRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
`

const Row = ({ children, ...props }) => {
    return <StyledRow {...props}>{children}</StyledRow>
}

export default Row
